export type StatoAccise = 'in_regola' | 'in_scadenza' | 'in_ritardo' | 'non_applicabile'

export interface RataAccisa {
  mese: number
  scadenza: string
  versato: boolean
}

const GIORNI_PREAVVISO = 30

export function statoAcciseMensili(rate: readonly RataAccisa[], oggi: Date = new Date()): StatoAccise {
  if (rate.length === 0) return 'non_applicabile'

  const nonVersate = rate.filter((r) => !r.versato)
  if (nonVersate.some((r) => new Date(r.scadenza) < oggi)) return 'in_ritardo'

  const imminenti = nonVersate.some((r) => {
    const giorni = Math.floor((new Date(r.scadenza).getTime() - oggi.getTime()) / 86_400_000)
    return giorni <= GIORNI_PREAVVISO
  })

  return imminenti ? 'in_scadenza' : 'in_regola'
}

export const ETICHETTA_STATO_ACCISE: Record<StatoAccise, string> = {
  in_regola: 'In regola',
  in_scadenza: 'In scadenza',
  in_ritardo: 'In ritardo',
  non_applicabile: 'Non applicabile',
}
